import { render, staticRenderFns } from "./CustomerInviteCreate.vue?vue&type=template&id=8bd5fc58&scoped=true"
import script from "./CustomerInviteCreate.vue?vue&type=script&lang=js"
export * from "./CustomerInviteCreate.vue?vue&type=script&lang=js"
import style0 from "./CustomerInviteCreate.vue?vue&type=style&index=0&id=8bd5fc58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd5fc58",
  null
  
)

export default component.exports